import type { ScoutlyticsUser } from '../types/user';

export const DISCORD_CONNECTED_LABEL = 'Discord connected';

export const DISCORD_READY_MATCHING_MESSAGE =
  "You're ready for profile matching after commissioner approval.";

export const DISCORD_PREP_CONNECT_MESSAGE =
  'Connect Discord to prepare for profile claiming';

type DiscordIdentityUser = Pick<
  ScoutlyticsUser,
  'discord_connected' | 'discord_id' | 'identities'
> | null | undefined;

/** True when the signed-in account has a linked Discord identity. */
export function hasConnectedDiscord(user: DiscordIdentityUser): boolean {
  if (!user) return false;
  if (user.discord_connected === true) return true;
  if (user.discord_id) return true;
  const identities = user.identities ?? [];
  return identities.some((identity) => {
    const provider = (identity.provider || '').toLowerCase();
    if (provider !== 'discord') return false;
    return Boolean(identity.provider_user_id || identity.username);
  });
}
